<template>
  <div class="home main">
      <h2>
        الإجراءات والتدابير الاستثنائية المتعلقة بإلغاء العقوبات الناجمة عن التأخر في تسديد الاشتراكات
      </h2>
    <br>

    <section>

<template lang="html">
  <div class="">


    <h3>
      Center
    </h3>
    <vs-tabs alignment="center">
      <vs-tab label="Home">
        <div>

        </div>
      </vs-tab>
      <vs-tab label="Documents">
        <div>

        </div>
      </vs-tab>
      <vs-tab label="Contributors">
        <div>

        </div>
      </vs-tab>
      <vs-tab label="Ecosystem">
        <div>

        </div>
      </vs-tab>
    </vs-tabs>

    


  </div>
</template>

    </section>

  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  }
}
</script>
